export const COMMON_BUS_COMPONENTS_LIST = [
    {
        name: 'mainPagePositions',
        title: 'Открытые позиции',
        id: 'positions',
        translationName: 'mainPage',
        translation: () => import('@/assets/rawData/i18n/mainPage.json')
    },
    {
        name: 'mainPageBids',
        title: 'Лимитные заявки',
        id: 'bids',
        translationName: 'mainPage',
        translation: () => import('@/assets/rawData/i18n/mainPage.json')
    },
    {
        name: 'currencyWallet',
        title: 'Фьючерсный счет',
        id: 'currencyWallet',
        translationName: 'mainPage',
        translation: () => import('@/assets/rawData/i18n/mainPage.json')
    },
    {
        name: 'spotWallet',
        title: 'Спотовый счет',
        id: 'spotWallet',
        translationName: 'mainPage',
        translation: () => import('@/assets/rawData/i18n/mainPage.json')
    },
    {
        name: 'internalTransfers',
        title: 'Внутренние переводы',
        id: 'internalTransfers',
        translationName: 'mainPage',
        translation: () => import('@/assets/rawData/i18n/mainPage.json')
    },
    {
        name: 'spotPage',
        title: 'Спотовый кошелек',
        id: 'spot',
        translationName: 'spotPage',
        translation: () => import('@/assets/rawData/i18n/spotPage.json')
    },
    {
        name: 'leveragesPage',
        title: 'Плечи',
        id: 'leverages',
        translationName: 'leveragesPage',
        translation: () => import('@/assets/rawData/i18n/leveragesPage.json')
    },
    {
        name: 'whitelists',
        title: 'Белый список адресов',
        id: 'whitelists',
        translationName: 'whitelistsPage',
        translation: () => import('@/assets/rawData/i18n/whitelistsPage.json')
    },
    {
        name: 'outboundTransfers',
        title: 'Вывод средств',
        id: 'outboundTransfers',
        translationName: 'transfersPage',
        translation: () => import('@/assets/rawData/i18n/transfersPage.json')
    },
    {
        name: 'inboundTransfers',
        title: 'Ввод средств',
        id: 'inboundTransfers',
        translationName: 'transfersPage',
        translation: () => import('@/assets/rawData/i18n/transfersPage.json')
    }
];
